import { useContext } from 'react'
import Thumb, { THUMB_SIZE } from '../../../components/Thumb'
import CONST from '../../../utils/const'
import { GameDifficultyContext } from '../../../utils/GameModeContext'
import ThumbChooserLayout from './ThumbChooserLayout'

const ThumbChooser = ({ onUserChosen }) => {
  const { difficulty } = useContext(GameDifficultyContext)
  const thumbsToShow = Object.keys(CONST.WHO_BEATS_WHO[difficulty])

  return (
    <ThumbChooserLayout>
      {thumbsToShow.map((thumb) => (
        <Thumb
          className={thumb}
          key={thumb}
          thumbSize={THUMB_SIZE.SMALL}
          thumbType={thumb}
          onClick={() => {
            onUserChosen(thumb)
          }}
        />
      ))}
    </ThumbChooserLayout>
  )
}

export default ThumbChooser
